export enum Views {
  EMBLEMS = "EMBLEMS",
}

export const Steps = {
  BackgroundPattern: "BackgroundPattern",
  Backing: "Backing",
  BorderColor: "BorderColor",
  BorderType: "BorderType",
  Combination: "Combination",
  DesignType: "DesignType",
  Emblem3d: "Emblem3d",
  EmblemLeather: "EmblemLeather",
  EmblemPrintStitch: "EmblemPrintStitch",
  FabricColor: "FabricColor",
  FabricType: "FabricType",
  GarmentType: "GarmentType",
  HolographicColors: "HolographicColors",
  HolographicUpload: "HolographicUpload",
  Layout: "Layout",
  Location: "Location",
  ProductSubtype: "ProductSubtype",
  ProductType: "ProductType",
  RequestDetails: "RequestDetails",
  Scrolling: "Scrolling",
  ScrollingText: "ScrollingText",
  ScrollingFont: "ScrollingFont",
  ScrollingFontDisplayName: "ScrollingFontDisplayName",
  SewingChannel: "SewingChannel",
  SewingGuideColor: "SewingGuideColor",
  Shape: "Shape",
  SizeStandard: "SizeStandard",
  ThreadColors: "ThreadColors",
}